"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconMailbox = void 0;

var React = __importStar(require("react"));

exports.IconMailbox = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "35",
    height: "32",
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    d: "M34.297 22.2844H32.7302V6.96386H26.4627V5.91928C26.4627 2.64683 23.8159 0 20.5434 0C20.4387 0 20.2999 4.15079e-08 20.1952 0.0353625V0H5.91928C2.64683 0 0 2.64683 0 5.91928V26.2193H11.247V32H16.1217V26.2193H34.297V22.2844ZM31.3374 22.2844H16.0169V16.3651L18.1414 17.9673L20.6835 16.5392L29.8413 21.4832L30.5024 20.2645L22.1102 15.738L30.6409 11.0374L29.9445 9.8187L20.6819 14.9723H20.6465V15.0077L18.2786 16.3311L16.0153 14.6255V8.35802H31.3358L31.3374 22.2844ZM25.0699 5.91928V6.96386H16.0169V5.91928C16.0169 3.41257 18.0367 1.39277 20.5434 1.39277C23.0501 1.39277 25.0699 3.41257 25.0699 5.91928ZM1.39277 5.91928C1.39277 3.41257 3.41257 1.39277 5.91928 1.39277H16.7488C15.4608 2.47273 14.6243 4.10896 14.6243 5.91928V22.2844H1.39291L1.39277 5.91928ZM32.9043 24.8265H1.39277V23.6772H32.9043V24.8265Z",
    fill: color
  }), React.createElement("path", {
    d: "M2.4375 6.96387V11.5952C2.4375 12.6751 3.30798 13.5796 4.42192 13.5796H5.36177C6.44172 13.5796 7.34619 12.7091 7.34619 11.5952V10.62H12.5691V6.96394L2.4375 6.96387ZM11.1423 9.22712H5.91943V11.5951C5.91943 11.9079 5.67597 12.1868 5.32778 12.1868H4.38794C4.07511 12.1868 3.79629 11.9433 3.79629 11.5951V8.35664H11.1083V9.22712H11.1423Z",
    fill: color
  }), React.createElement("path", {
    d: "M3.13379 19.0813H11.7693V20.4741H3.13379V19.0813Z",
    fill: color
  }));
});